module.exports = __webpack_public_path__ + "img/woods_2.6e84dcea.png";